import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { useMediaQuery } from "native-base";
import "./style.css";
import { MOBILE_VIEW_WIDTH } from "../../../utils/screens";

const PieCharts = ({ labels = [], data = [], activeTab }) => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const [chartData, setChartData] = useState({
    labels: [],
    series: [],
  });

  useEffect(() => {
    if (labels.length > 0 && data.length > 0) {
      const generatedData = data[0]?.data || [];

      setChartData({
        labels: labels,
        series: generatedData,
      });
    }
  }, [labels, data]);

  const options = {
    labels: chartData.labels,
    tooltip: {
      enabled: true,
      y: {
        formatter: function (val) {
          if (Number.isInteger(val)) {
            return val.toFixed(0);
          } else {
            return val.toFixed(2);
          }
        },
      },
    },
    dataLabels: {
      offset: 0,
      minAngleToShowLabel: 0,
      enabled: false,
      formatter: function (val, opts) {
        const seriesIndex = opts.seriesIndex;

        if (Number.isInteger(chartData.series[seriesIndex])) {
          return chartData.series[seriesIndex].toFixed(0);
        } else {
          return chartData.series[seriesIndex].toFixed(2);
        }
      },
    },
    legend: {
      position: MobileWindow ? "bottom" : "right",
      formatter: function (val, opts) {
        const seriesValue = chartData.series[opts.seriesIndex];
        const formattedValue = Number.isInteger(seriesValue)
          ? seriesValue.toFixed(0)
          : seriesValue.toFixed(2);
          return `<span style="font-size: 18px; font-weight: bold;">${val} - <strong>${formattedValue}</strong></span>`;
      },
    },
    colors:
      activeTab === "event"
        ? [
            "#5fcbef",
            "#2e83c3",
            "#42d0a2",
            "#2e946b",
            "#326014",
            "#96d141",
            "#128db6",
          ]
        : [
            "#90c226",
            "#54a021",
            "#e6b91e",
            "#e76618",
            "#c42f1a",
            "#918655",
            "#567417",
            "#326014",
            "#326644",
            "#8c7010",
          ],
  };

  return (
    <div
      className="App"
      style={{ width: "100%", maxHeight: MobileWindow ? "600px" : "350px" }}
    >
      <div
        style={{
          height: "auto",
          maxHeight: MobileWindow ? "600px" : "350px",
          width: "100%",
        }}
      >
        <Chart
          options={options}
          series={chartData.series}
          type="pie"
          height={MobileWindow ? "600" : "350"}
          className="custom-chart"
        />
      </div>
    </div>
  );
};

export default PieCharts;
